import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import moment from 'moment';
import { MdModeEdit } from "react-icons/md";
import ChangeUserRole from '../components/ChangeUserRole';
import ChangeUserVerification from '../components/ChangeUserVerification';
import { FaCreditCard, FaShoppingCart } from 'react-icons/fa';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import { AiFillEye } from "react-icons/ai";
import { useSelector } from 'react-redux';
import { AiOutlineUserAdd } from "react-icons/ai";
import AddUser from '../components/AddUser';
import UserCertificate from '../components/UserCertificate';
import ChangeUserType from '../components/ChangeTypeUser';

const AllUsers = () => {
    const user = useSelector(state => state?.user?.user);
    const [allUser, setAllUsers] = useState([]);
    const [loading, setLoading] = useState(true); 
    const [openUpdateRole, setOpenUpdateRole] = useState(false);
    const [openUpdateVerified, setOpenUpdateVerified] = useState(false);
    const [openUpdateType, setOpenUpdateType] = useState(false);
    const [updateUserDetails, setUpdateUserDetails] = useState({
        email: "",
        name: "",
        role: "",
        _id: "",
        isVerified: false,
        type:"",
    });
    const navigate = useNavigate(); 
    const [openAddUser, setOpenAddUser] = useState(false);
    const [openUserCertificate, setOpenUserCertificate] = useState(false);
    const [userCertificate, setUserCertificate] = useState({});


    const fetchAllUsers = async () => {
        try {
            setLoading(true);
            const fetchData = await fetch(SummaryApi.allUser.url, {
                method: SummaryApi.allUser.method,
                credentials: 'include',
            });
    
            const dataResponse = await fetchData.json();
    
            if (dataResponse.success) {
                
                const rolePriority = {
                    ADMIN: 1,
                    SALESMAN: 2,
                    GENERAL: 3,
                };
    
                const sortedUsers = dataResponse.data.sort((a, b) => {
                    const roleComparison = rolePriority[a.role] - rolePriority[b.role];
                    if (roleComparison !== 0) {
                        return roleComparison;
                    }
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
    
                setAllUsers(sortedUsers);
            } else {
                toast.error(dataResponse.message);
            }
        } catch (error) {
        } finally {
            setLoading(false); 
        }
    };

    useEffect(() => {
        fetchAllUsers();
    }, []);

    const isAdmin = allUser.length > 0 && user?.type === 'Admin';

    return (
        <div className="bg-white pb-4">
           <div className="bg-white pb-4">
  {/* New User Button */}
  {user?.type === "Admin" && (
    <div className="flex justify-end mb-4">
      <button 
        className="bg-blue-900 text-white py-2 px-4 rounded-md hover:bg-blue-800"
        onClick={() => setOpenAddUser(true)}
      >
        <AiOutlineUserAdd />
      </button>
    </div>
  )}
</div>


            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
                </div>
            ) : allUser.length === 0 ? (
                <p className="text-center text-gray-500">لا يوجد مستخدمين</p>
            ) : (
                <div className="overflow-x-auto">
                <table className="w-full userTable">
                    <thead>
                        <tr className="bg-black text-white text-xs sm:text-base">
                            <th className="p-2">الترتيب</th>
                            <th className="p-2">الاسم</th> 
                            <th className="p-2">البريد الالكترونى</th>
                            <th className="p-2">رقم الهاتف المحمول </th>
                            <th className="p-2">تاريخ التسجيل</th>
                            <th className="p-2">الصلاحيات</th>
                             {user?.type === 'Admin' && (
                                <>
                                    <th className="p-2">النوع</th>
                                </>
                            )}
                            <th className="p-2">التوثيق</th>
                            {/* 
                            {user?.type === 'Admin' && (
                                <>
                                    <th className="p-2">شهادة التوثيق</th>
                                </>
                            )}
                                */}
                            {user?.type !== 'Admin' && (
                                <>
                                    <th className="p-2">المديونية</th>
                                    <th className="p-2">الفواتير</th>
                                    <th className="p-2">الحسابات</th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {allUser.map((el, index) => (
                            <tr key={el._id} className="text-xs sm:text-base">
                                <td className="p-2">{index + 1}</td>
                                <td className="p-2">{el?.name}</td>
                                <td className="p-2">{el?.email}</td>
                                <td className="p-2">{el?.mobileNumber}</td>
                                <td className="p-2">{moment(el?.createdAt).format('LL')}</td>
                                <td className="p-2">
                                    {el?.role}
                                    {isAdmin &&el.role!=='GENERAL'&& (
                                        <button
                                            className="bg-green-100 p-2 rounded-full cursor-pointer hover:bg-green-500 hover:text-white ml-2"
                                            onClick={() => {
                                                setUpdateUserDetails(el);
                                                setOpenUpdateRole(true);
                                            }}
                                        >
                                            <MdModeEdit />
                                        </button>
                                    )}
                                </td>
                                {user?.type==='Admin'&&(
                                <td className="p-2">
                                    {el?.type }
                                    {isAdmin &&el.role!=='GENERAL'&& (
                                        <button
                                            className="bg-yellow-100 p-2 rounded-full cursor-pointer hover:bg-yellow-500 hover:text-white ml-2"
                                            onClick={() => {
                                                setUpdateUserDetails(el);
                                                setOpenUpdateType(true);
                                            }}
                                        >
                                            <MdModeEdit />
                                        </button>
                                    )}
                                </td>
                                )}
                                <td className="p-2">
                                    {el?.isVerified ? "Yes" : "No"}
                                    {isAdmin && (
                                        <button
                                            className="bg-red-100 p-2 rounded-full cursor-pointer hover:bg-red-500 hover:text-white ml-2"
                                            onClick={() => {
                                                setUpdateUserDetails(el);
                                                setOpenUpdateVerified(true);
                                            }}
                                        >
                                            <MdModeEdit />
                                        </button>
                                    )}
                                </td>
                                {user?.type !== 'Admin' && el.role === 'GENERAL' && (
                                    <>
                                        <td className="p-2">
                                        <button
                                            className="bg-yellow-100 p-2 rounded-full cursor-pointer hover:bg-yellow-500 hover:text-white"
                                            onClick={() => {
                                                navigate(`/admin-panel/adminViewUserRequest/${el._id}`, { state: { type: user?.type } });
                                            }}
                                        >

                                                <FaCreditCard />
                                            </button>
                                        </td>
                                        <td className="p-2">
                                            <button
                                                className="bg-purple-100 p-2 rounded-full cursor-pointer hover:bg-purple-500 hover:text-white"
                                                onClick={() => {
                                                    navigate(`/admin-panel/adminViewUserOrders/${el._id}`, { state: { type: user?.type } });
                                                }}
                                            >
                                                <FaShoppingCart />
                                            </button>
                                        </td>
                                        {el.role === 'GENERAL' && el.pharmacistOrPharmacy==='pharmacy'&&<td className="p-2">
                                <button
                                                className="bg-blue-100 p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white"
                                                onClick={() => {
                                                    navigate(`/admin-panel/adminPaymentAndOrders/${el._id}`, { state: { type: user?.type } });
                                                }}
                                            >
                                <AiFillEye/>
                                </button>
                                </td>}
                                      
                                    </>
                                )}
                                {el.role !== 'GENERAL' && (
                                    <>
                                        <td className="p-2"></td>
                                        <td className="p-2"></td>
                                        <td className="p-2"></td>
                                    </>
                                )}

                           {/*
                               {user?.type === 'Admin' && el.role === 'GENERAL' && (
                                    <td className="p-2">
                                        <button
                                            className="bg-blue-100 p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white"
                                            onClick={() => {
                                                setUserCertificate({
                                                    name: el.name,
                                                    email: el.email,
                                                    certificatePic: el.certificatePic,
                                                });
                                                setOpenUserCertificate(true);
                                            }}
                                        >
                                            <AiFillEye />
                                        </button>
                                    </td>
                                )}
                                    */}
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
                </div>
            )}

            {/* Role modal */}
            {openUpdateRole && (
                <ChangeUserRole
                    onClose={() => setOpenUpdateRole(false)}
                    name={updateUserDetails.name}
                    email={updateUserDetails.email}
                    role={updateUserDetails.role}
                    userId={updateUserDetails._id}
                    callFunc={fetchAllUsers}
                />
            )}

            {/* Verification modal */}
            {openUpdateVerified && (
                <ChangeUserVerification
                    onClose={() => setOpenUpdateVerified(false)}
                    name={updateUserDetails.name}
                    email={updateUserDetails.email}
                    isVerified={updateUserDetails.isVerified}
                    userId={updateUserDetails._id}
                    callFunc={fetchAllUsers}
                />
            )}

            {openUpdateType && (
                <ChangeUserType
                    onClose={() => setOpenUpdateType(false)}
                    name={updateUserDetails.name}
                    email={updateUserDetails.email}
                    role={updateUserDetails.role}
                    type={updateUserDetails.type}
                    userId={updateUserDetails._id}
                    callFunc={fetchAllUsers}
                />
            )}

            {/** Add New User */}
            {openAddUser && (
                 <AddUser onClose={() => setOpenAddUser(false)} fetchData={fetchAllUsers} />
            )}

            {openUserCertificate && (
            <UserCertificate
                name={userCertificate.name}
                email={userCertificate.email}
                certificatePic={userCertificate.certificatePic}
                onClose={() => setOpenUserCertificate(false)}
            />
            )}




        </div>
    );
};

export default AllUsers;
